module.exports = __webpack_public_path__ + "r-v3/img/icon_mic_off.3b8e20f7.svg";